import { ReactComponent as AppsAndSoftware } from './Apps and Software.svg';
import { ReactComponent as BankCharges } from './Bank Charges.svg';
import { ReactComponent as CreditCardBill } from './Credit Card Bill.svg';
import { ReactComponent as Others } from './OTHERS.svg';
import { ReactComponent as SalaryIcon } from './Salary.svg';
import { ReactComponent as BankingAndFinance } from './banking and finance.svg';
import { ReactComponent as Bills } from './bills.svg';
import { ReactComponent as CashTransaction } from './cash transaction.svg';
import { ReactComponent as DebitCardTransaction } from './debit card transaction.svg';
import { ReactComponent as Donation } from './donation.svg';
import { ReactComponent as Education } from './education.svg';
import { ReactComponent as Entertainment } from './entertainment.svg';
import { ReactComponent as FoodAndDrinks } from './food and drinks.svg';
import { ReactComponent as GeneralTransaction } from './general transaction.svg';
import { ReactComponent as Govt } from './govt.svg';
import { ReactComponent as HealthAndWellness } from './health and wellness.svg';
import { ReactComponent as Household } from './household.svg';
import { ReactComponent as Insurance } from './insurance.svg';
import { ReactComponent as Interest } from './interest.svg';
import { ReactComponent as InvestmentLiquidation } from './investment liquidation.svg';
import { ReactComponent as Investment } from './investment.svg';
import { ReactComponent as Loans } from './loans.svg';
import { ReactComponent as Person } from './person.svg';
import { ReactComponent as ReversalsAndRefunds } from './reversals and refunds.svg';
import { ReactComponent as SelfTransfer } from './self transfer.svg';
import { ReactComponent as Services } from './services.svg';
import { ReactComponent as Shopping } from './shopping.svg';
import { ReactComponent as Travel } from './travel.svg';
import { ReactComponent as WalletAndDigitalPayments } from './wallet and digital payments.svg';
import { ReactComponent as OtherBobV2 } from '../../BOB/v2/OTHERS.svg';
import { ReactComponent as P2PLending } from '../../BOB/v2/p2p_lending.svg';
import { ReactComponent as TransferIn } from '../../BOB/v2/transfer-in.svg';
import { ReactComponent as TransferOut } from '../../BOB/v2/transfer_out.svg';
import { ReactComponent as Salary } from '../../BOB/v2/salary.svg';
import { ReactComponent as InvestmentIncome } from '../../BOB/v2/investment-income.svg';
import { ReactComponent as InternalTransfer } from '../../BOB/v2/internal-transfer.svg';
import { ReactComponent as Emi } from '../../BOB/v2/emi.svg';
import { ReactComponent as RentBOB } from '../../BOB/v2/rent.svg';
import { ReactComponent as Rent } from './rent.svg';
import { ReactComponent as CardPayments } from '../../BOB/v2/card-payments.svg';
import { getTenant } from '../../../Utils/storageUtils';
import { TenantType } from '../../../Utils/types';

// Keys are lowercase for case-insensitive lookup
const categoryIconMap: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  'apps and software': AppsAndSoftware,
  'bank charges': BankCharges,
  'credit card bill': CreditCardBill,
  others: Others,
  salary: SalaryIcon,
  'banking and finance': BankingAndFinance,
  bills: Bills,
  'cash transaction': CashTransaction,
  'debit card transaction': DebitCardTransaction,
  'debit card transactions': DebitCardTransaction,
  donation: Donation,
  education: Education,
  entertainment: Entertainment,
  'food and drinks': FoodAndDrinks,
  'general transaction': GeneralTransaction,
  'general transactions': GeneralTransaction,
  govt: Govt,
  'health and wellness': HealthAndWellness,
  household: Household,
  insurance: Insurance,
  interest: Interest,
  'investment liquidation': InvestmentLiquidation,
  investment: Investment,
  loans: Loans,
  person: Person,
  rent: Rent,
  'reversals and refunds': ReversalsAndRefunds,
  'self transfer': SelfTransfer,
  services: Services,
  shopping: Shopping,
  travel: Travel,
  'wallet and digital payments': WalletAndDigitalPayments,
};

const categoryIconsBobV2: Record<
  string,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  P2P_LENDING: P2PLending,
  P2P_TRANSFER: P2PLending,
  TRANSFER_IN: TransferIn,
  TRANSFER_OUT: TransferOut,
  SALARY: Salary,
  INVESTMENT_INCOME: InvestmentIncome,
  INTERNAL_TRANSFER: InternalTransfer,
  EMI: Emi,
  CREDIT_CARD_PAYMENT: CardPayments,
  RENT: RentBOB,
};

export const getCategoryIcon = (
  categoryName: string
): React.FC<React.SVGProps<SVGSVGElement>> => {
  if (getTenant() === TenantType.BOB_V2)
    return categoryIconsBobV2[categoryName] || OtherBobV2;
  return categoryIconMap[categoryName.toLowerCase()] || Others;
};

export { Others as OthersIcon };
